import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a73ab84"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mt-2"
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-4 mt-3"
}, null, -1));
const _hoisted_5 = {
  key: 0,
  class: "i-layer"
};
const _hoisted_6 = {
  class: "row"
};
const _hoisted_7 = {
  class: "col-12 mb-3"
};
const _hoisted_8 = {
  class: "fw-medium fsi-14 d-flex justify-content-center align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_9 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_10 = {
  style: {
    "margin-top": "1rem"
  },
  class: "col-12"
};
const _hoisted_11 = {
  key: 1,
  class: "i-layer"
};
const _hoisted_12 = {
  class: "row"
};
const _hoisted_13 = {
  class: "col-12 mb-3"
};
const _hoisted_14 = {
  class: "mb-4"
};
const _hoisted_15 = {
  class: "ml-2 mt-2"
};
const _hoisted_16 = {
  class: "link-text",
  target: "_blank",
  href: "https://docs.stfil.io/v/cn/"
};
const _hoisted_17 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_18 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_19 = {
  class: "d-none d-md-block mt-2",
  style: {
    "min-height": "100px"
  },
  "element-loading-text": "Loading..."
};
const _hoisted_20 = {
  class: "node-row-head"
};
const _hoisted_21 = {
  style: {
    "width": "15%"
  },
  class: "flex-center"
};
const _hoisted_22 = {
  style: {
    "width": "30%"
  },
  class: "flex-center"
};
const _hoisted_23 = {
  style: {
    "width": "30%"
  },
  class: "flex-center"
};
const _hoisted_24 = {
  style: {
    "width": "15%"
  },
  class: "flex-center"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "10%"
  },
  class: "flex-center"
}, null, -1));
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  style: {
    "width": "15%"
  },
  class: "flex-center"
};
const _hoisted_28 = {
  style: {
    "width": "30%"
  },
  class: "flex-center"
};
const _hoisted_29 = {
  style: {
    "width": "30%"
  },
  class: "flex-center"
};
const _hoisted_30 = {
  style: {
    "width": "10%"
  },
  class: "flex-center"
};
const _hoisted_31 = {
  key: 0,
  class: "flex-center mt-5"
};
const _hoisted_32 = {
  style: {
    "color": "#b8b8b8"
  },
  class: "fsi-14"
};
const _hoisted_33 = {
  class: "d-block d-md-none mt-2",
  style: {
    "min-height": "100px"
  },
  "element-loading-text": "Loading..."
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  class: "d-flex"
};
const _hoisted_36 = {
  style: {
    "width": "85%"
  }
};
const _hoisted_37 = {
  class: "d-flex align-items-center justify-content-between mb-1"
};
const _hoisted_38 = {
  class: "d-flex align-items-center justify-content-between mb-1"
};
const _hoisted_39 = {
  class: "d-flex align-items-center justify-content-between mb-1"
};
const _hoisted_40 = {
  class: "d-flex align-items-center justify-content-between"
};
const _hoisted_41 = {
  style: {
    "width": "15%"
  },
  class: "flex-center justify-content-end"
};
const _hoisted_42 = {
  key: 1,
  style: {
    "width": "100%",
    "height": "1px",
    "background-color": "rgb(232 232 232)"
  }
};
const _hoisted_43 = {
  key: 0,
  class: "flex-center mt-5"
};
const _hoisted_44 = {
  style: {
    "color": "#b8b8b8"
  },
  class: "fsi-14"
};
const _hoisted_45 = {
  key: 0,
  style: {
    "margin-top": "2rem"
  }
};
const _hoisted_46 = {
  key: 0
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row mb-3 mt-3"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "col-12 mb-1"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-18"
}, "Provide Guarantee For Node")])], -1));
const _hoisted_48 = {
  class: "row mt-3"
};
const _hoisted_49 = {
  class: "col-12"
};
const _hoisted_50 = {
  key: 0,
  class: "row mb-3 i-layer"
};
const _hoisted_51 = {
  class: "col-12 mb-1"
};
const _hoisted_52 = {
  key: 1,
  class: "row mt-4"
};
const _hoisted_53 = {
  class: "col-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_Tip = _resolveComponent("Tip");
  const _component_SuccessFilled = _resolveComponent("SuccessFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Singer = _resolveComponent("Singer");
  const _component_AdCard2 = _resolveComponent("AdCard2");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.Node')) + " f0" + _toDisplayString($props.nodeId), 1)]), _hoisted_4, !$data.noGuaranteeNode ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('farm.The current node is a collateralized node')) + ":" + _toDisplayString($data.guaranteeNodeId), 1)])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
    class: "btn btn-outline-clear w-100 i-button",
    onClick: $options.back,
    loading: $data.loading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.return')), 1)]),
    _: 1
  }, 8, ["onClick", "loading"])])])])) : _createCommentVNode("", true), $data.noGuaranteeNode ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_Tip, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, " 1." + _toDisplayString(_ctx.$t('farm.collateralNode.rule1')), 1), _createElementVNode("div", null, " 2." + _toDisplayString(_ctx.$t('farm.collateralNode.rule2')), 1), _createElementVNode("div", null, " 3." + _toDisplayString(_ctx.$t('farm.collateralNode.rule3')), 1), _createElementVNode("div", null, " 4." + _toDisplayString(_ctx.$t('farm.collateralNode.rule4')), 1), _createElementVNode("div", null, " 5." + _toDisplayString(_ctx.$t('farm.collateralNode.rule5')), 1), _createElementVNode("div", null, [_createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.$t('stake.LearnMore')), 1)])])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('farm.Please select a collateralized node')), 1)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('farm.Node')), 1), _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('farm.Position')), 1), _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('farm.Debt')), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('farm.DebtRatio')), 1), _hoisted_25]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sameOwnerNodes, (item, index) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [!$data.readySign || $data.checkIndex === index ? (_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["node-row", $data.checkIndex === index ? 'node-row-check' : '']),
      key: index,
      onClick: $event => $options.checkNode(index)
    }, [_createElementVNode("div", _hoisted_27, "f0" + _toDisplayString(item.node), 1), _createElementVNode("div", _hoisted_28, _toDisplayString($options.externalFormatFilPrice(item.position_value)), 1), _createElementVNode("div", _hoisted_29, _toDisplayString($options.externalFormatFilPrice(item.debt_value)), 1), _createElementVNode("div", {
      style: {
        "width": "15%"
      },
      class: _normalizeClass(["flex-center", $options.debtRatioColor({
        debt_value: item.debt_value,
        position_value: item.position_value,
        max_debt_ratio: item.max_leverage,
        liq_threshold: item.liquidation_threshold
      })])
    }, _toDisplayString($options.formatUnits($options.debtRatio({
      debt_value: item.debt_value,
      position_value: item.position_value
    }), 2)) + "%", 3), _createElementVNode("div", _hoisted_30, [$data.checkIndex === index ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 0,
      size: "20",
      color: "#6752F0"
    }, {
      default: _withCtx(() => [_createVNode(_component_SuccessFilled)]),
      _: 1
    })) : _createCommentVNode("", true)])], 10, _hoisted_26)) : _createCommentVNode("", true)], 64);
  }), 256)), !$data.loadingNode && $data.sameOwnerNodes.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('farm.Cannot find a node with the same owner')), 1)])) : _createCommentVNode("", true)])), [[_directive_loading, $data.loadingNode]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sameOwnerNodes, (item, index) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: index
    }, [!$data.readySign || $data.checkIndex === index ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["node-row-md", $data.checkIndex === index ? 'node-row-check' : '']),
      onClick: $event => $options.checkNode(index)
    }, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.Node')), 1), _createElementVNode("div", null, "f0" + _toDisplayString(item.node), 1)]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.Position')), 1), _createElementVNode("div", null, _toDisplayString($options.externalFormatFilPrice(item.position_value)), 1)]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.Debt')), 1), _createElementVNode("div", null, _toDisplayString($options.externalFormatFilPrice(item.debt_value)), 1)]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.DebtRatio')), 1), _createElementVNode("div", {
      class: _normalizeClass($options.debtRatioColor({
        debt_value: item.debt_value,
        position_value: item.position_value,
        max_debt_ratio: item.max_leverage,
        liq_threshold: item.liquidation_threshold
      }))
    }, _toDisplayString($options.formatUnits($options.debtRatio({
      debt_value: item.debt_value,
      position_value: item.position_value
    }), 2)) + "% ", 3)])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", null, [$data.checkIndex === index ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 0,
      size: "24",
      color: "#6752F0"
    }, {
      default: _withCtx(() => [_createVNode(_component_SuccessFilled)]),
      _: 1
    })) : _createCommentVNode("", true), $data.checkIndex !== index ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 1,
      size: "24",
      color: "#cccccc"
    }, {
      default: _withCtx(() => [_createVNode(_component_SuccessFilled)]),
      _: 1
    })) : _createCommentVNode("", true)])])])], 10, _hoisted_34)) : _createCommentVNode("", true), $data.checkIndex !== index && index !== $data.sameOwnerNodes.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_42)) : _createCommentVNode("", true)], 64);
  }), 128)), !$data.loadingNode && $data.sameOwnerNodes.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('farm.Cannot find a node with the same owner')), 1)])) : _createCommentVNode("", true)])), [[_directive_loading, $data.loadingNode]]), !$data.readySign && $data.sameOwnerNodes.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_45, [$data.nodeHealthyErr ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    disabled: true,
    class: "btn btn-info w-100 i-button"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.The debt of the node has exceeded the maximum debt')), 1)]),
    _: 1
  })) : _createCommentVNode("", true), !$data.nodeHealthyErr ? (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    disabled: $data.checkIndex < 0,
    class: "btn btn-primary w-100 i-button",
    onClick: $options.reapprove,
    loading: $data.loading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Confirm')), 1)]),
    _: 1
  }, 8, ["disabled", "onClick", "loading"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), $data.readySign ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_hoisted_47, _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createVNode(_component_Singer, {
    ref: "singer",
    nodeRole: $data.nodeRole,
    singerMultiple: $data.singerMultiple,
    singerType: "approval",
    waitTime: 30000,
    btnProposal: "Send Proposal",
    "contract-method": $data.contractMethod,
    contractParams: $data.contractParams,
    onNext: $options.complete,
    originalSingerTables: $data.singerTables
  }, null, 8, ["nodeRole", "singerMultiple", "contract-method", "contractParams", "onNext", "originalSingerTables"])])]), $data.showCancel && !$data.completeFlag ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createVNode(_component_el_button, {
    class: "btn btn-outline-clear w-100 i-button",
    onClick: $options.reset
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('change.cancel')), 1)]),
    _: 1
  }, 8, ["onClick"])])])) : _createCommentVNode("", true), $data.completeFlag ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createVNode(_component_AdCard2, {
    title: `${_ctx.$t('farm.You have successfully collateralized the node')}(f0${$data.sameOwnerNodes[$data.checkIndex].node})`,
    "btn-text": _ctx.$t('Onboarding.View Node'),
    onBtnClick: $options.viewNode
  }, null, 8, ["title", "btn-text", "onBtnClick"])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
}